
/* START_TEMPLATE */
define('hbs!app/templates/recaptcha_grid',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data,depths) {
  var stack1, buffer = "    <div class=\"at-recaptcha-wrapper\">\n";
  stack1 = helpers.each.call(depth0, depth0, {"name":"each","hash":{},"fn":this.program(2, data, depths),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "    </div>\n";
},"2":function(depth0,helpers,partials,data,depths) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, lambda=this.lambda;
  return "            <div class=\"at-recaptcha clearfix\">\n                <div data-choice=\""
    + escapeExpression(((helper = (helper = helpers.idx || (depth0 != null ? depth0.idx : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"idx","hash":{}}) : helper)))
    + "\"\n                     style=\"width: "
    + escapeExpression(lambda((depths[2] != null ? depths[2].cellWidth : depths[2]), depth0))
    + "; height: "
    + escapeExpression(lambda((depths[2] != null ? depths[2].cellHeight : depths[2]), depth0))
    + ";\n                             background-image:url('"
    + escapeExpression(lambda((depths[2] != null ? depths[2].img : depths[2]), depth0))
    + "');\n                             background-size:"
    + escapeExpression(((helper = (helper = helpers.bkgSize || (depth0 != null ? depth0.bkgSize : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"bkgSize","hash":{}}) : helper)))
    + ";\n                             background-position:"
    + escapeExpression(((helper = (helper = helpers.bkgPos || (depth0 != null ? depth0.bkgPos : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"bkgPos","hash":{}}) : helper)))
    + ";\">\n                </div>\n            </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,depths) {
  var stack1, buffer = "<div class=\"at-recaptcha-table\">\n";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.gridRow : depth0), {"name":"each","hash":{},"fn":this.program(1, data, depths),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</div>\n";
},"useDepths":true});
Handlebars.registerPartial('app/templates/recaptcha_grid', t);
return t;
});
/* END_TEMPLATE */
;
